export class FullLink {
  constructor() {
    const fullLinks = document.querySelectorAll('.full-link');
    const fullLinksPortfolio = document.querySelectorAll('.full-link.portfolio');

    fullLinks.forEach(link => {
      link?.addEventListener('click', e => {
        e.preventDefault();
        window.location.href = `${e.currentTarget.id}`;
      });
    })

    fullLinksPortfolio.forEach(link => {
      link?.addEventListener('click', e => {
        e.preventDefault();
        window.location.href = `/portfolio/${e.currentTarget.id}`;
      });
    })
  }
}

export default new FullLink;
